// Browser fingerprinting for anonymous user identification
export const generateFingerprint = (): string => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  
  // Get screen info
  const screen = `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`;
  
  // Get timezone
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  // Get user agent
  const userAgent = navigator.userAgent;
  
  // Get language
  const language = navigator.language;
  
  // Canvas fingerprint
  let canvasFingerprint = '';
  if (ctx) {
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Anonymous fingerprint', 2, 2);
    canvasFingerprint = canvas.toDataURL();
  }
  
  // Combine all factors
  const combined = `${screen}|${timezone}|${userAgent}|${language}|${canvasFingerprint}`;
  
  // Simple hash function
  let hash = 0;
  for (let i = 0; i < combined.length; i++) {
    const char = combined.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  return Math.abs(hash).toString(36);
};

// Store fingerprint in localStorage for consistency
export const getStoredFingerprint = (): string => {
  let fingerprint = localStorage.getItem('user_fingerprint');
  
  if (!fingerprint) {
    fingerprint = generateFingerprint();
    localStorage.setItem('user_fingerprint', fingerprint);
  }
  
  return fingerprint;
};